<template>
  <v-dialog v-model="dialog" :max-width="width" persistent :fullscreen="fullscreen">
    <v-card outlined scrollable color="#fefefe">
      <v-app-bar color="blue-grey lighten-5" dense flat>
        <v-icon class="mr-2" color="">{{ icon }}</v-icon>
        <h3>{{ title }}</h3>
        <v-spacer></v-spacer>
        <v-btn depressed fab tile dark color="#EF5350" @click="close()" x-small>
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-divider></v-divider>
      <v-container fluid>
        <slot></slot>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TheDialog',
  data: () => ({
    dialog: false,
  }),
  props: {
    value: Boolean,
    title: String,
    icon: String,
    width: {
      type: String,
      default: '700px',
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.dialog = false
      this.externalClose()
    },
    externalClose() {
      this.$emit('closeFunction')
    },
  },
  watch: {
    dialog() {
      this.$emit('input', this.dialog)
    },
    value() {
      this.dialog = this.value
    },
  },
}
</script>
